const _ = "styles-module__banner___FiIzf", e = "styles-module__banner__icon___0lMOW", n = "styles-module__banner__close___Qvy6H", r = "styles-module__banner__title___LucHD", t = "styles-module__banner__desc___E-T0U", a = "styles-module__banner__link___Fyrgg", l = "styles-module__banner__buttons___UG3NP", s = "styles-module__banner__placeholder___IXBkd", b = {
  banner: _,
  "banner--primary": "styles-module__banner--primary___sjhIq",
  "banner--primary-blue": "styles-module__banner--primary-blue___LOoMq",
  "banner--primary-dark": "styles-module__banner--primary-dark___xq-L6",
  "banner--primary-light": "styles-module__banner--primary-light___tuMfk",
  "banner--primary-brand": "styles-module__banner--primary-brand___tAlL1",
  "banner--secondary": "styles-module__banner--secondary___KxuDa",
  "banner--secondary-50": "styles-module__banner--secondary-50___cc02l",
  "banner--secondary-100": "styles-module__banner--secondary-100___T6eK-",
  "banner--secondary-200": "styles-module__banner--secondary-200___fJVr8",
  "banner--secondary-300": "styles-module__banner--secondary-300___iInCh",
  "banner--secondary-400": "styles-module__banner--secondary-400___aX-nW",
  "banner--secondary-500": "styles-module__banner--secondary-500___UOXCd",
  "banner--secondary-600": "styles-module__banner--secondary-600___lFoF3",
  "banner--secondary-700": "styles-module__banner--secondary-700___co13U",
  "banner--secondary-800": "styles-module__banner--secondary-800___yrf3x",
  "banner--secondary-900": "styles-module__banner--secondary-900___NNH3Y",
  "banner--tertiary": "styles-module__banner--tertiary___Tl7ZD",
  "banner--tertiary-50": "styles-module__banner--tertiary-50___BqM4d",
  "banner--tertiary-100": "styles-module__banner--tertiary-100___8XY3O",
  "banner--tertiary-200": "styles-module__banner--tertiary-200___S508F",
  "banner--tertiary-300": "styles-module__banner--tertiary-300___-jS4M",
  "banner--tertiary-400": "styles-module__banner--tertiary-400___4vRik",
  "banner--tertiary-450": "styles-module__banner--tertiary-450___xYoKR",
  "banner--tertiary-500": "styles-module__banner--tertiary-500___6EEHZ",
  "banner--tertiary-600": "styles-module__banner--tertiary-600___Db2tW",
  "banner--tertiary-700": "styles-module__banner--tertiary-700___rzWkj",
  "banner--tertiary-800": "styles-module__banner--tertiary-800___pm7k2",
  "banner--tertiary-900": "styles-module__banner--tertiary-900___IJwwK",
  "banner--quaternary": "styles-module__banner--quaternary___cXlui",
  "banner--quaternary-50": "styles-module__banner--quaternary-50___DV0mn",
  "banner--quaternary-100": "styles-module__banner--quaternary-100___OpeN2",
  "banner--quaternary-200": "styles-module__banner--quaternary-200___COcxY",
  "banner--quaternary-300": "styles-module__banner--quaternary-300___Ocd8J",
  "banner--quaternary-400": "styles-module__banner--quaternary-400___uGRVx",
  "banner--quaternary-500": "styles-module__banner--quaternary-500___dH647",
  "banner--quaternary-600": "styles-module__banner--quaternary-600___yh6pB",
  "banner--quaternary-700": "styles-module__banner--quaternary-700___PubEg",
  "banner--quaternary-800": "styles-module__banner--quaternary-800___iRVcB",
  "banner--quaternary-900": "styles-module__banner--quaternary-900___eUE24",
  "banner--info": "styles-module__banner--info___Pijld",
  "banner--info-50": "styles-module__banner--info-50___dVqOq",
  "banner--info-100": "styles-module__banner--info-100___mkKXw",
  "banner--info-200": "styles-module__banner--info-200___0fD2M",
  "banner--info-300": "styles-module__banner--info-300___S0g3F",
  "banner--info-400": "styles-module__banner--info-400___Upany",
  "banner--info-500": "styles-module__banner--info-500___D3WKO",
  "banner--info-600": "styles-module__banner--info-600___XMh0-",
  "banner--info-700": "styles-module__banner--info-700___qu3CN",
  "banner--info-800": "styles-module__banner--info-800___gpThr",
  "banner--info-900": "styles-module__banner--info-900___-iGge",
  "banner--success": "styles-module__banner--success___dTJdN",
  "banner--success-50": "styles-module__banner--success-50___EC94E",
  "banner--success-100": "styles-module__banner--success-100___y6Mv0",
  "banner--success-200": "styles-module__banner--success-200___DSCfH",
  "banner--success-300": "styles-module__banner--success-300___QDRNY",
  "banner--success-400": "styles-module__banner--success-400___W-ek-",
  "banner--success-500": "styles-module__banner--success-500___3njRx",
  "banner--success-600": "styles-module__banner--success-600___04NIu",
  "banner--success-700": "styles-module__banner--success-700___7cTzw",
  "banner--success-800": "styles-module__banner--success-800___2wN2c",
  "banner--success-900": "styles-module__banner--success-900___W5TLs",
  "banner--alert": "styles-module__banner--alert___EZoJ-",
  "banner--alert-50": "styles-module__banner--alert-50___8L1p4",
  "banner--alert-100": "styles-module__banner--alert-100___jaaIQ",
  "banner--alert-200": "styles-module__banner--alert-200___IntYD",
  "banner--alert-300": "styles-module__banner--alert-300___FZMFt",
  "banner--alert-400": "styles-module__banner--alert-400___zZijF",
  "banner--alert-500": "styles-module__banner--alert-500___9WPmV",
  "banner--alert-600": "styles-module__banner--alert-600___9LLJv",
  "banner--alert-700": "styles-module__banner--alert-700___YssyN",
  "banner--alert-800": "styles-module__banner--alert-800___Dnkw2",
  "banner--alert-900": "styles-module__banner--alert-900___QRiHc",
  "banner--error": "styles-module__banner--error___U-Huq",
  "banner--error-50": "styles-module__banner--error-50___87Bq3",
  "banner--error-100": "styles-module__banner--error-100___G9Y2A",
  "banner--error-200": "styles-module__banner--error-200___BazUp",
  "banner--error-300": "styles-module__banner--error-300___eMScw",
  "banner--error-400": "styles-module__banner--error-400___aGneX",
  "banner--error-500": "styles-module__banner--error-500___67rFt",
  "banner--error-600": "styles-module__banner--error-600___cfH7S",
  "banner--error-700": "styles-module__banner--error-700___84SiI",
  "banner--error-800": "styles-module__banner--error-800___ycwz-",
  "banner--error-900": "styles-module__banner--error-900___4nsgw",
  "banner--neutral": "styles-module__banner--neutral___ML5iY",
  "banner--neutral-50": "styles-module__banner--neutral-50___A1U0F",
  "banner--neutral-100": "styles-module__banner--neutral-100___NmIrb",
  "banner--neutral-150": "styles-module__banner--neutral-150___r2xTG",
  "banner--neutral-200": "styles-module__banner--neutral-200___zfsWY",
  "banner--neutral-300": "styles-module__banner--neutral-300___605r5",
  "banner--neutral-400": "styles-module__banner--neutral-400___irCye",
  "banner--neutral-500": "styles-module__banner--neutral-500___ldAc2",
  "banner--neutral-600": "styles-module__banner--neutral-600___hyOi8",
  "banner--neutral-700": "styles-module__banner--neutral-700___gHq-W",
  "banner--neutral-800": "styles-module__banner--neutral-800___k96YX",
  "banner--neutral-900": "styles-module__banner--neutral-900___PPrwx",
  "banner--grey": "styles-module__banner--grey___xn6hm",
  "banner--grey-50": "styles-module__banner--grey-50___vkIJb",
  "banner--grey-100": "styles-module__banner--grey-100___y0yOF",
  "banner--grey-200": "styles-module__banner--grey-200___eilAW",
  "banner--grey-300": "styles-module__banner--grey-300___Q88LV",
  "banner--grey-400": "styles-module__banner--grey-400___Z7tXm",
  "banner--grey-500": "styles-module__banner--grey-500___Kv4Bb",
  "banner--grey-600": "styles-module__banner--grey-600___HH-j5",
  "banner--grey-700": "styles-module__banner--grey-700___sh8vQ",
  "banner--grey-800": "styles-module__banner--grey-800___cCADi",
  "banner--grey-900": "styles-module__banner--grey-900___UzAf1",
  "banner--background": "styles-module__banner--background___8-yV3",
  "banner--background-200": "styles-module__banner--background-200___0tqQm",
  "banner--background-full-white": "styles-module__banner--background-full-white___3bu9H",
  "banner--background-grey-50": "styles-module__banner--background-grey-50___otHLZ",
  "banner--background-neutral-50": "styles-module__banner--background-neutral-50___9qzoq",
  "banner--background-grey-100": "styles-module__banner--background-grey-100___xljvo",
  "banner--background-tertiary": "styles-module__banner--background-tertiary___JaRtH",
  "banner--background-error": "styles-module__banner--background-error___-AB9U",
  "banner--background-tertiary-600": "styles-module__banner--background-tertiary-600___IZsTD",
  "banner--background-error-600": "styles-module__banner--background-error-600___JBy4v",
  "banner--background-neutral-900": "styles-module__banner--background-neutral-900___WcwDe",
  "banner--background-neutral-legacy": "styles-module__banner--background-neutral-legacy___b9tea",
  "banner--background-win": "styles-module__banner--background-win___DB0Bz",
  "banner--typography": "styles-module__banner--typography___ZhwIK",
  "banner--typography-white": "styles-module__banner--typography-white___URnyR",
  "banner--typography-default": "styles-module__banner--typography-default___i6QCC",
  "banner--typography-link": "styles-module__banner--typography-link___j8S00",
  "banner--typography-error": "styles-module__banner--typography-error___Yzlhz",
  "banner--typography-sucess": "styles-module__banner--typography-sucess___CdYs0",
  "banner--typography-disabled": "styles-module__banner--typography-disabled___6e66V",
  "banner--typography-marketing": "styles-module__banner--typography-marketing___AjSP4",
  "banner--typography-secondary": "styles-module__banner--typography-secondary___vs3Ps",
  "banner--icons-white": "styles-module__banner--icons-white___F8n8N",
  "banner--icons-dark-grey": "styles-module__banner--icons-dark-grey___iVvPX",
  "banner--icons-blue": "styles-module__banner--icons-blue___FKbDm",
  "banner--icons-red": "styles-module__banner--icons-red___hVfSN",
  "banner--icons-success": "styles-module__banner--icons-success___RMBzp",
  "banner--icons-warning": "styles-module__banner--icons-warning___9Ra2U",
  "banner--icons-info": "styles-module__banner--icons-info___waMxq",
  "banner--icons-win": "styles-module__banner--icons-win___66sAJ",
  "banner--accent": "styles-module__banner--accent___Ir0Vi",
  "banner--accent-orange": "styles-module__banner--accent-orange___UyXrb",
  "banner--accent-light": "styles-module__banner--accent-light___zIiLc",
  banner__icon: e,
  banner__close: n,
  banner__title: r,
  "banner__title--primary": "styles-module__banner__title--primary___6nda1",
  "banner__title--primary-blue": "styles-module__banner__title--primary-blue___-hPYm",
  "banner__title--primary-dark": "styles-module__banner__title--primary-dark___E5A97",
  "banner__title--primary-light": "styles-module__banner__title--primary-light___9bFFd",
  "banner__title--primary-brand": "styles-module__banner__title--primary-brand___mirlW",
  "banner__title--secondary": "styles-module__banner__title--secondary___GtRZs",
  "banner__title--secondary-50": "styles-module__banner__title--secondary-50___WFGJB",
  "banner__title--secondary-100": "styles-module__banner__title--secondary-100___dfKyw",
  "banner__title--secondary-200": "styles-module__banner__title--secondary-200___Ac8W-",
  "banner__title--secondary-300": "styles-module__banner__title--secondary-300___tBlw5",
  "banner__title--secondary-400": "styles-module__banner__title--secondary-400___XTEKR",
  "banner__title--secondary-500": "styles-module__banner__title--secondary-500___niHyI",
  "banner__title--secondary-600": "styles-module__banner__title--secondary-600___eqb-f",
  "banner__title--secondary-700": "styles-module__banner__title--secondary-700___-yeej",
  "banner__title--secondary-800": "styles-module__banner__title--secondary-800___MIpJF",
  "banner__title--secondary-900": "styles-module__banner__title--secondary-900___WL7rb",
  "banner__title--tertiary": "styles-module__banner__title--tertiary___r800R",
  "banner__title--tertiary-50": "styles-module__banner__title--tertiary-50___YPjEf",
  "banner__title--tertiary-100": "styles-module__banner__title--tertiary-100___WA4--",
  "banner__title--tertiary-200": "styles-module__banner__title--tertiary-200___wj57t",
  "banner__title--tertiary-300": "styles-module__banner__title--tertiary-300___xD31D",
  "banner__title--tertiary-400": "styles-module__banner__title--tertiary-400___ZCUFY",
  "banner__title--tertiary-450": "styles-module__banner__title--tertiary-450___qUOK3",
  "banner__title--tertiary-500": "styles-module__banner__title--tertiary-500___b-riY",
  "banner__title--tertiary-600": "styles-module__banner__title--tertiary-600___pRMCL",
  "banner__title--tertiary-700": "styles-module__banner__title--tertiary-700___pgF2I",
  "banner__title--tertiary-800": "styles-module__banner__title--tertiary-800___7-O9c",
  "banner__title--tertiary-900": "styles-module__banner__title--tertiary-900___zNEip",
  "banner__title--quaternary": "styles-module__banner__title--quaternary___YSULG",
  "banner__title--quaternary-50": "styles-module__banner__title--quaternary-50___hAMUX",
  "banner__title--quaternary-100": "styles-module__banner__title--quaternary-100___cFcTI",
  "banner__title--quaternary-200": "styles-module__banner__title--quaternary-200___94gKL",
  "banner__title--quaternary-300": "styles-module__banner__title--quaternary-300___AIKfX",
  "banner__title--quaternary-400": "styles-module__banner__title--quaternary-400___4fAao",
  "banner__title--quaternary-500": "styles-module__banner__title--quaternary-500___XrwTS",
  "banner__title--quaternary-600": "styles-module__banner__title--quaternary-600___KAWbu",
  "banner__title--quaternary-700": "styles-module__banner__title--quaternary-700___TjTs2",
  "banner__title--quaternary-800": "styles-module__banner__title--quaternary-800___x0mSv",
  "banner__title--quaternary-900": "styles-module__banner__title--quaternary-900___a-GSv",
  "banner__title--info": "styles-module__banner__title--info___5p1w7",
  "banner__title--info-50": "styles-module__banner__title--info-50___xJqEq",
  "banner__title--info-100": "styles-module__banner__title--info-100___HRZZ8",
  "banner__title--info-200": "styles-module__banner__title--info-200___G-isp",
  "banner__title--info-300": "styles-module__banner__title--info-300___d-6LC",
  "banner__title--info-400": "styles-module__banner__title--info-400___FoWM0",
  "banner__title--info-500": "styles-module__banner__title--info-500___XhEJx",
  "banner__title--info-600": "styles-module__banner__title--info-600___9K3re",
  "banner__title--info-700": "styles-module__banner__title--info-700___UY3fD",
  "banner__title--info-800": "styles-module__banner__title--info-800___iTdM6",
  "banner__title--info-900": "styles-module__banner__title--info-900___Ja-CP",
  "banner__title--success": "styles-module__banner__title--success___Z03wZ",
  "banner__title--success-50": "styles-module__banner__title--success-50___6sdv0",
  "banner__title--success-100": "styles-module__banner__title--success-100___Uoxma",
  "banner__title--success-200": "styles-module__banner__title--success-200___OgyWx",
  "banner__title--success-300": "styles-module__banner__title--success-300___hC-P3",
  "banner__title--success-400": "styles-module__banner__title--success-400___SOakq",
  "banner__title--success-500": "styles-module__banner__title--success-500___CFDw-",
  "banner__title--success-600": "styles-module__banner__title--success-600___vyVNU",
  "banner__title--success-700": "styles-module__banner__title--success-700___fLQ1i",
  "banner__title--success-800": "styles-module__banner__title--success-800___WU7B8",
  "banner__title--success-900": "styles-module__banner__title--success-900___r-dpO",
  "banner__title--alert": "styles-module__banner__title--alert___UzBsp",
  "banner__title--alert-50": "styles-module__banner__title--alert-50___VHLv3",
  "banner__title--alert-100": "styles-module__banner__title--alert-100___hdNT7",
  "banner__title--alert-200": "styles-module__banner__title--alert-200___jLqEv",
  "banner__title--alert-300": "styles-module__banner__title--alert-300___-dzFs",
  "banner__title--alert-400": "styles-module__banner__title--alert-400___F3w-I",
  "banner__title--alert-500": "styles-module__banner__title--alert-500___YJ3L9",
  "banner__title--alert-600": "styles-module__banner__title--alert-600___pIAG5",
  "banner__title--alert-700": "styles-module__banner__title--alert-700___UJaUt",
  "banner__title--alert-800": "styles-module__banner__title--alert-800___kx9OC",
  "banner__title--alert-900": "styles-module__banner__title--alert-900___LJXxL",
  "banner__title--error": "styles-module__banner__title--error___qmbTn",
  "banner__title--error-50": "styles-module__banner__title--error-50___hzmm3",
  "banner__title--error-100": "styles-module__banner__title--error-100___T3NqA",
  "banner__title--error-200": "styles-module__banner__title--error-200___1yiCB",
  "banner__title--error-300": "styles-module__banner__title--error-300___sMJWZ",
  "banner__title--error-400": "styles-module__banner__title--error-400___OXjzV",
  "banner__title--error-500": "styles-module__banner__title--error-500___63lEE",
  "banner__title--error-600": "styles-module__banner__title--error-600___IpVSm",
  "banner__title--error-700": "styles-module__banner__title--error-700___Ektbp",
  "banner__title--error-800": "styles-module__banner__title--error-800___muoXS",
  "banner__title--error-900": "styles-module__banner__title--error-900___TwCWL",
  "banner__title--neutral": "styles-module__banner__title--neutral___5EZsk",
  "banner__title--neutral-50": "styles-module__banner__title--neutral-50___H-q17",
  "banner__title--neutral-100": "styles-module__banner__title--neutral-100___PwjyM",
  "banner__title--neutral-150": "styles-module__banner__title--neutral-150___Zv9-3",
  "banner__title--neutral-200": "styles-module__banner__title--neutral-200___PVqyd",
  "banner__title--neutral-300": "styles-module__banner__title--neutral-300___kOGZH",
  "banner__title--neutral-400": "styles-module__banner__title--neutral-400___ZBFmx",
  "banner__title--neutral-500": "styles-module__banner__title--neutral-500___jUmU-",
  "banner__title--neutral-600": "styles-module__banner__title--neutral-600___TIVdt",
  "banner__title--neutral-700": "styles-module__banner__title--neutral-700___NOyaH",
  "banner__title--neutral-800": "styles-module__banner__title--neutral-800___JtN9Z",
  "banner__title--neutral-900": "styles-module__banner__title--neutral-900___X-NXi",
  "banner__title--grey": "styles-module__banner__title--grey___GZMQT",
  "banner__title--grey-50": "styles-module__banner__title--grey-50___xEBZI",
  "banner__title--grey-100": "styles-module__banner__title--grey-100___LJhGp",
  "banner__title--grey-200": "styles-module__banner__title--grey-200___XxFB8",
  "banner__title--grey-300": "styles-module__banner__title--grey-300___fSM8V",
  "banner__title--grey-400": "styles-module__banner__title--grey-400___NPyL6",
  "banner__title--grey-500": "styles-module__banner__title--grey-500___oLFo2",
  "banner__title--grey-600": "styles-module__banner__title--grey-600___WY-nW",
  "banner__title--grey-700": "styles-module__banner__title--grey-700___tJtFi",
  "banner__title--grey-800": "styles-module__banner__title--grey-800___qWNrh",
  "banner__title--grey-900": "styles-module__banner__title--grey-900___jO-vC",
  "banner__title--background": "styles-module__banner__title--background___Ud9Fi",
  "banner__title--background-200": "styles-module__banner__title--background-200___lYM7M",
  "banner__title--background-full-white": "styles-module__banner__title--background-full-white___FyjNq",
  "banner__title--background-grey-50": "styles-module__banner__title--background-grey-50___d7F1E",
  "banner__title--background-neutral-50": "styles-module__banner__title--background-neutral-50___Oikx0",
  "banner__title--background-grey-100": "styles-module__banner__title--background-grey-100___4z0-m",
  "banner__title--background-tertiary": "styles-module__banner__title--background-tertiary___US2gr",
  "banner__title--background-error": "styles-module__banner__title--background-error___wqXAt",
  "banner__title--background-tertiary-600": "styles-module__banner__title--background-tertiary-600___DXoh9",
  "banner__title--background-error-600": "styles-module__banner__title--background-error-600___lLtiK",
  "banner__title--background-neutral-900": "styles-module__banner__title--background-neutral-900___izySb",
  "banner__title--background-neutral-legacy": "styles-module__banner__title--background-neutral-legacy___3styq",
  "banner__title--background-win": "styles-module__banner__title--background-win___e-Abz",
  "banner__title--typography": "styles-module__banner__title--typography___Wy5OY",
  "banner__title--typography-white": "styles-module__banner__title--typography-white___bMcE5",
  "banner__title--typography-default": "styles-module__banner__title--typography-default___V6-k7",
  "banner__title--typography-link": "styles-module__banner__title--typography-link___8PfLq",
  "banner__title--typography-error": "styles-module__banner__title--typography-error___LHFxx",
  "banner__title--typography-sucess": "styles-module__banner__title--typography-sucess___Vwr-X",
  "banner__title--typography-disabled": "styles-module__banner__title--typography-disabled___40vUN",
  "banner__title--typography-marketing": "styles-module__banner__title--typography-marketing___H3HLr",
  "banner__title--typography-secondary": "styles-module__banner__title--typography-secondary___nyA1w",
  "banner__title--icons-white": "styles-module__banner__title--icons-white___VwUrY",
  "banner__title--icons-dark-grey": "styles-module__banner__title--icons-dark-grey___-ZZOq",
  "banner__title--icons-blue": "styles-module__banner__title--icons-blue___MwBfC",
  "banner__title--icons-red": "styles-module__banner__title--icons-red___NBxkz",
  "banner__title--icons-success": "styles-module__banner__title--icons-success___YSmyl",
  "banner__title--icons-warning": "styles-module__banner__title--icons-warning___amA3L",
  "banner__title--icons-info": "styles-module__banner__title--icons-info___5R5f5",
  "banner__title--icons-win": "styles-module__banner__title--icons-win___oGmGj",
  "banner__title--accent": "styles-module__banner__title--accent___aRij6",
  "banner__title--accent-orange": "styles-module__banner__title--accent-orange___TSM0Q",
  "banner__title--accent-light": "styles-module__banner__title--accent-light___4-RvC",
  banner__desc: t,
  banner__link: a,
  banner__buttons: l,
  banner__placeholder: s,
  "banner--warning": "styles-module__banner--warning___i1sKV"
};
export {
  _ as banner,
  l as banner__buttons,
  n as banner__close,
  t as banner__desc,
  e as banner__icon,
  a as banner__link,
  s as banner__placeholder,
  r as banner__title,
  b as default
};
